// extracted by mini-css-extract-plugin
module.exports = {"container":"e_mr","image":"e_nr","imageImage":"e_or","description":"e_pr","title":"e_qr","button":"e_rr"};